import React, { useRef } from "react";
import { Element } from "react-scroll";
import { Container, Typography, Paper, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import contacts from "../RESTDATA";
import DefaultButton from "../components/DefaultButton";
import Seo from "../components/Seo";
import { useTranslation } from "react-i18next";
import { useMyContext } from "../MyContext";
import { scroller } from "react-scroll";

function Career() {
  const careerRef = useRef();
  const location = useLocation();
  const { isSmallScreen } = useMyContext();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const restTitle = contacts.name;
  const phone = contacts.phone;
  const rate = 5;
  const fontS = isSmallScreen ? "h5" : "h2";
  const fontM = isSmallScreen ? "h3" : "h1";
  const handleEmailClick = () => {
    window.location.href = `mailto:${contacts.email}`;
  };
  const handleContacts = () => {
    scroller.scrollTo("contacts", {
      smooth: true,
    });
  };

  return (
    <>
      <Seo
        title={t("career.title")}
        description={t("career.join")}
        pathname={location.pathname}
        lang={lang}
      />
      <Element id="career" ref={careerRef}>
        <Container maxWidth="md">
          <Box my={4}>
            <Typography
              variant={fontM}
              my={1}
              align="center"
              color="primary.red"
              gutterBottom
            >
              {t("career.title")}
            </Typography>

          <Paper
            elevation={3}
            sx={{ bgcolor: "secondary.bgmain", p: 3, mb: 3 }}
          >
            <Typography variant={fontS} gutterBottom>
              {t("career.join")}
            </Typography>
            <Typography paragraph>
              {t("career.text1", { restTitle })}
            </Typography>
          </Paper>

          <Paper elevation={3} sx={{ bgcolor: "text.green", p: 3, mb: 3 }}>
            <Typography variant={fontS} gutterBottom>
              {t("career.why")}
            </Typography>
            <Typography paragraph>
              <strong> {t("career.1")}</strong> {t("career.1a")}
            </Typography>
            <Typography paragraph>
              <strong> {t("career.2")}</strong> {t("career.2a")}
            </Typography>
            <Typography paragraph>
              <strong> {t("career.3")}</strong> {t("career.3a")}
            </Typography>
            <Typography paragraph>
              <strong> {t("career.4")}</strong> {t("career.4a")}
            </Typography>
          </Paper>

          <Paper elevation={3} sx={{ bgcolor: "text.green", p: 3, mb: 3 }}>
            <Typography variant={fontS} gutterBottom>
              {t("career.positions")}
            </Typography>
            <Typography variant="h4" gutterBottom>
              {t("career.waiters.title")}
            </Typography>
            <Typography paragraph>{t("career.waiters.description")}</Typography>
            <Typography paragraph>
              <strong>{t("career.waiters.rate")}</strong>{" "}
              {t("career.waiters.rate1", { rate })}
            </Typography>

            <Typography variant="h4" gutterBottom>
              {t("career.cooks.title")}
            </Typography>
            <Typography paragraph>{t("career.cooks.description")}</Typography>
            <Typography paragraph>
              <strong>{t("career.waiters.rate", { rate })}</strong>{" "}
              {t("career.waiters.rate1", { rate })}
            </Typography>
          </Paper>

          <Box display="flex" justifyContent="center" flexDirection="column">
            <DefaultButton
              variant="contained"
              label={t("career.applyButton")}
              color="primary"
              relative
              minWidth="100%"
              onClick={handleEmailClick}
            ></DefaultButton>
            <DefaultButton
              variant="contained"
              label="Contacts"
              color="secondary"
              relative
              minWidth="100%"
              onClick={handleContacts}
            ></DefaultButton>
          </Box>
        </Box>
      </Container>
    </Element>
    </>
  );
}

export default Career;
